angular.module('unica_archive_event.archive_event_controllers')

.controller('ArchiveEventListController', function(
	$rootScope, $scope, $state,
	$confirm, $stateParams,
	ArchiveEventListService, ArchiveEventEditService
) {
	$scope.eventList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	if ( $stateParams.year ) {
		$rootScope.year = $stateParams.year;
	} else if ( !$rootScope.year ) {
		$state.go('app.event.years');
	}

	$scope.loadEvents = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		ArchiveEventListService
			.list($rootScope.year, $scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					data = $rootScope.parseStages( data );

					$scope.eventList = $scope.eventList.concat( data );
					if ( data.length === 0 || data.length < $scope.limit ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadEvents();

	$scope.restoreEvent = function(eventId) {

		$confirm({
			title: 'Sei sicuro di voler ripristinare l\'evento?',
			text: 'Confermi il ripristino dell\'evento?'
		}).then(function() {

			$scope.showLoader();
			ArchiveEventEditService
				.restore( eventId  )
				.then(function(data) {
					$scope.hideLoader();

					if (data && !data.error) {
						angular.forEach($scope.eventList, function(event, key) {
							if ( event.id == eventId ) {
								$scope.eventList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Evento ripristinato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

	$scope.previewEvent = function(eventId) {
		var sess = null,//JSON.parse( localStorage.getItem('session') ),
			url  = window.location.origin + window.location.pathname + 'event/' + eventId + '/preview';

		if ( sess.manager_media_permission ) {
			url += '?id=' + sess.id;
		}

		window.open( url  ,'_blank');
	};

});